import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../../utils/gtm';

export default function GTMPageTracker() {
  const location = useLocation();

  useEffect(() => {
    trackPageView({
      page_title: document.title,
      page_path: `${location.pathname}${location.search}`,
      page_location: window.location.href,
    });
  }, [location.pathname, location.search]);

  return null;
}
